module.exports = __webpack_public_path__ + "static/media/payment-icon2.9c4ed057.svg";